
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 7c-3.44 0-6.558 1.894-8.86 4.97a.721.721 0 000 .856C5.443 15.906 8.56 17.8 12 17.8c3.44 0 6.558-1.894 8.86-4.97a.721.721 0 000-.856C18.557 8.894 15.44 7 12 7zm.247 9.203c-2.283.144-4.168-1.75-4.025-4.051.118-1.898 1.646-3.436 3.531-3.555 2.283-.144 4.168 1.75 4.025 4.051-.122 1.894-1.65 3.432-3.531 3.555zm-.114-1.757a2.042 2.042 0 01-2.166-2.18 2.054 2.054 0 011.904-1.916 2.042 2.042 0 012.165 2.18 2.054 2.054 0 01-1.903 1.916z","fill":"#4788C6","fill-rule":"nonzero"}})])
          )
        }
      }
    